<template>
    <div>
        <v-container fluid :style="{ 'min-height': '800px' }">
            <v-container class="contain-width">

                <v-row>
                    <v-col
                            cols="12"
                        md="8"
                        offset-md="2"
                        lg="6"
                        offset-lg="3"
                    >
                        <h1 class="mt-6 mb-6">{{ $t('headings.Contact us') }}</h1>
                        <v-card
                                class="mx-auto form-card"
                                outlined
                        >

                            <v-card-text class="text--primary">
                              <p>{{ $t('Email') }}: <a :href="'mailto:' + supportEmail">{{ supportEmail }}</a></p>
                              <p>If you would like to request your account to be deleted, please email us from the same email your account was created with. This will affect the following services:</p>
                              <ul>
                                <li>findmykit.com</li>
                                <li>neotag.es</li>
                                <li>Findmykit app on Play store and IOS store (developer Find my Kit)</li>
                                <li>Neotag app on Play store and IOS store (developer Find my Kit)</li>
                              </ul>
                              <p>We will anonymise all your personal data from our database.</p>
                              <p>Any outstanding subscriptions will be cancelled.</p>
                              <p>We will notify you by email once this is completed.</p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>

    import Footer from './Footer.vue'
    import {i18n} from "../i18n";
    import {mapState} from "vuex";
    import {store} from "../store";

    export default {
        name: "ContactUs",
        metaInfo () {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.Contact us'),
            htmlAttrs: {
              lang: i18n.locale
            },
            meta: [
              { name: 'description', content: 'Contact us. Send us an email if you have any questions on our service, or if you have any constructive feedback, that will help us improve our service to you.' }
            ]
          }
        },
        components: {
            'Footer': Footer
        },
        methods: {
          capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
          },
        },
        computed: {
          ...mapState({
            brand: state => state.brand,
            brandName: state => state.brandName
          }),
          getBackground() {
            if (this.brand === 'neotag') {
              return require('@/assets/neotag-background.jpg')
            }
            else {
              return require('@/assets/neotag-background.jpg')
            }
          },
          supportEmail() {
            if (this.brand === 'neotag') {
              return 'info@neotag.es'
            }
            else {
              return 'support@findmykit.com'
            }
          }
        },
        mounted () {

            window.scrollTo(0,0);

            window.prerenderReady = true;
        }
    }
</script>

<style scoped>

</style>
